"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeadcountRange = void 0;
var HeadcountRange;
(function (HeadcountRange) {
    HeadcountRange["SMALL"] = "1-10";
    HeadcountRange["MEDIUM"] = "10-50";
    HeadcountRange["LARGE"] = "50-100";
    HeadcountRange["VERY_LARGE"] = "100-300";
    HeadcountRange["EXTRA_LARGE"] = "300+";
})(HeadcountRange || (exports.HeadcountRange = HeadcountRange = {}));
//# sourceMappingURL=headcountRange.enum.js.map